<template>
    <identification :title="$translate('Select login method')" />
</template>

<script>
import Identification from './Identification.vue'
export default {
    name: 'zoezi-login',

    zoezi: {
        title: 'Log in',
        icon: 'mdi-login'
    },

    props: {
        linkAfterLogin: {
            title: 'Go to link after logging in',
            type: String,
            fulltype: 'page',
            default: '/'
        }
    },

    components: {
        Identification
    },

    watch: {
        '$store.state.isLoggedIn': {
            immediate: true,
            handler(isLoggedIn) {
                if (isLoggedIn && this.$route.path != this.linkAfterLogin && !this.$root.edit) {
                    this.$router.push({path: this.linkAfterLogin});
                }
            }
        },
    },
}
</script>
